import React from 'react'

import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import BackImg from './../../Public/Image/Login/Back.svg'
import TextField from '@mui/material/TextField';
import './AddEmail.css'
import { useSelector, useDispatch } from 'react-redux'
import { SetEmail } from './../../app/Slice'
import { useHistory } from 'react-router-dom';
import 'react-spring-bottom-sheet/dist/style.css'
// import ImageBottomSheet from './../../Public/Image/Register/BottomSheetIcon.svg'

// import { CheckEmailApi } from './../Api/CheckEmailApi'
import Snackbar from '@mui/material/Snackbar';
import { GetCookie } from './../../Action/GetCookie'
import { setMiniLoading } from './../../app/Home'
import { AllApi } from './../../Api/AllApi'
import { setTooManyLogin } from './../../app/Home'
import TooManyRequestBSh from './../../BottomSheet/TooManyRequestBSh'
import { db } from './../../DataBase/db'

const AddEmail = () => {
  const history = useHistory();

  const MiniLoading = useSelector((state) => state.Home.MiniLoading)
  const [state, setState] = React.useState({
    opens: false,
    vertical: 'top',
    horizontal: 'center',
  });
  const { vertical, horizontal, opens } = state;
  const handleClick = (newState) => {
    setState({ ...newState, opens: true });
  };
  const handleClose = () => {
    setState({ ...state, opens: false });
  };


  const EmailFromRedux = useSelector((state) => state.counter.email)
  const dispatch = useDispatch()
  const [Email, setEmail] = useState('')
  const [Error, setError] = useState(false)
  const [EmailEmpty, setEmailEmpty] = useState(false)
  const [EmailExist, setEmailExist] = useState(false)
  const HandleEmailChange = (email) => {
    setEmailExist(false)
    let result = email.trim();
    result = result.toLowerCase();
    setEmailEmpty(false)
    setEmail(result)
    dispatch(SetEmail(result))
    setError(false)
  }
  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };
  const CheckEmail = async () => {
    dispatch(setMiniLoading(true))

    if (Email.length == 0) {
      setEmailEmpty(true)
    }
    let Validate = validateEmail(Email)
    if (Validate !== null) {
      const MakeApiClass = new AllApi();
      let CheckEmailApiResponse = await MakeApiClass.checkEmailAccount(Email)
      // let CheckEmailApiResponse = await CheckEmailApi(Email)
  
      if (CheckEmailApiResponse.code == 429) {
        dispatch(setTooManyLogin(true))
      }
      else if (CheckEmailApiResponse.code === 200) {

        // let Phone = localStorage.getItem("PhoneNumberLogin")
        // console.log(Phone)
        // // db.Data.toArray(async function (data) {

        // //   if (data.length > 0) {
        // //     let res1 = db.Data.where({ id: Number(1) }).modify({ Email: Email, PhoneNumber: Phone })

        // //   } else if (data.length == 0) {
        // //     let res1 = db.Data.add({ Email: Email, PhoneNumber: Phone })

        // //   }
        // // });
        localStorage.setItem("AddEmail", Email)
        history.push(`/AddEmailSetPassword?Email=${Email}`);
        // history.push(`/ChangePassword?key=${Res.data.key}&&email=${Email}`);
      } else if (CheckEmailApiResponse.code === 301) {

        setEmailExist(true)
      } else if (CheckEmailApiResponse.code == 120 || CheckEmailApiResponse.code == 121 || CheckEmailApiResponse.code == 122 || CheckEmailApiResponse.code == 123) {
        let name = "Token"
        let name1 = "active"
        document.cookie = name + '=; Max-Age=-99999999;';
        document.cookie = name1 + '=; Max-Age=-99999999;';
        history.push("/");
      }
      else {
        handleClick({ vertical: 'bottom', horizontal: 'center' })
      }
    } else {
      setError(true)
    }
    dispatch(setMiniLoading(false))

  }
  return (
    <div className='RegisterContainer'>
      <div className='RegisterHeader'>
        <Link to="/EditProfile" className='RegisterBackIcon'>
          <img src={BackImg} className='RegisterBackIconImg' />
        </Link>
        <div className='RegisterHeaderText'>
          Email
        </div>
      </div>
      <div className='RegisterBody1'>
        {/* <button onClick={()=>handleClick({ vertical: 'bottom', horizontal: 'center' })}>Open simple snackbar</button> */}
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={opens}
          onClose={handleClose}
          message="Something went wrong"
          key={vertical + horizontal}
          autoHideDuration={3000}
        />



        <div className='RegisterBodyText'>
          Please enter a Email for your account
        </div>
        <div className='RegisterEmailInput'>
          {
            EmailEmpty ?
              <TextField
                error
                id="outlined-error-helper-text"
                label="Email"
                value={Email}
                onChange={(e) => HandleEmailChange(e.target.value)}
                helperText="email  is empty"
                className='RegisterEmailTextField'
              />
              :
              Error ? <TextField
                error
                id="outlined-error-helper-text"
                label="Email"
                value={Email}
                onChange={(e) => HandleEmailChange(e.target.value)}
                helperText="email format is incorrect"
                className='RegisterEmailTextField'
              />
                :
                EmailExist ?
                  <TextField
                    error
                    id="outlined-error-helper-text"
                    label="Email"
                    value={Email}
                    onChange={(e) => HandleEmailChange(e.target.value)}
                    helperText="This email is already registered"
                    className='RegisterEmailTextField'
                  />
                  :
                  <TextField id="outlined-basic" label="Email" value={Email}
                    onChange={(e) => HandleEmailChange(e.target.value)}
                    variant="outlined" className='RegisterEmailTextField' />
          }


        </div>



      </div>
      <div className='AddEmailNote'>
        ⚠️ Note: <span className='AddEmailNoteInner'>Email cannot be changed, please enter carefully</span>
      </div>
      <TooManyRequestBSh />

      <div className='RegisterFooter'>
        <div className='RegisterLinkDiv'>
          <button className="RegisterLink" onClick={() => CheckEmail()}>
            {MiniLoading ?
              <div className="loadminijoin"></div>
              :
              'Next'
            }
          </button>
        </div>
      </div>
    </div>
  )
}

export default AddEmail